<template>
  <section class="section section-primary is-small animated preFadeInUp fadeInUp">
    <div class="container">
      <!-- Title -->

      <div class="columns is-centered has-text-centered" v-if="requestloading == true">
        <loading line-fg-color="#2d3f51" size="massive" class="margin-100" :spacing="55" text-fg-color="#fff"
          message="الرجاء الإنتظار" />
      </div>

      <div v-if=!requestloading>
        <div class="columns is-centered has-text-centered pb-20" v-if="
          !requestsuccess && !dateform && !requestfail
        ">
          <!-- Title -->
          <div class="content-wrapper animated preFadeInUp fadeInUp">
            <div class="section-title-wrapper has-text-centered mb-20">
              <div>
                <h2 class="clean-section-title has-text-white has-text-weight-bold pb-40">
                  كشف حساب
                </h2>
              </div>
            </div>
            <h2></h2>
            <div class="columns is-centered">
              <div class="column is-6">
                <div class="flex-card icon-card-hover wallet-card light-bordered padding-20" @click="getLast30()">
                  <h3 class="card-title">كشف أخر 30 حركة</h3>
                  <p class="card-description"></p>
                </div>
              </div>
              <div class="column is-6">
                <div class="flex-card icon-card-hover first-card light-bordered padding-20" @click="byDate()">
                  <h3 class="card-title">كشف بالفترة</h3>
                  <p class="card-description"></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="columns is-centered" v-if="
          !requestsuccess && dateform && !requestfail
        ">
          <div class="column is-3">
            <!-- Login form -->

            <h4 class="title is-4 has-text-white pb-20">كشف بالفترة</h4>
            <!-- <select v-model="year"   class="input is-medium">

  <option v-for="year in years" :value="year">{{ year }}</option>
          </select>-->
            <section class="pb-40">
              <v-date-picker mode="single" v-model="requestInfo.DateFrom" locale="ar"
                :popover="{ placement: 'bottom', visibility: 'click' }" :first-day-of-week="1">
                <b-field label="من" class="has-text-white is-medium">
                  <b-input type="text" :value="$root.dateformat(requestInfo.DateFrom)" expanded v-validate="'required'"
                    name="DateFrom"></b-input>
                </b-field>
              </v-date-picker>

              <span v-show="errors.has('DateFrom')" class="help is-danger is-centered mb-10">{{ errors.first("DateTo")
                }}</span>

              <v-date-picker mode="single" v-model="requestInfo.DateTo" locale="ar"
                :popover="{ placement: 'bottom', visibility: 'click' }" :first-day-of-week="1">
                <b-field label="الي" class="has-text-white is-medium">
                  <b-input type="text" :value="$root.dateformat(requestInfo.DateTo)" expanded v-validate="'required'"
                    name="DateTo"></b-input>
                </b-field>
              </v-date-picker>

              <span v-show="errors.has('DateTo')" class="help is-danger is-centered mb-10">{{ errors.first("DateTo")
                }}</span>

              <!-- <b-field label="نوع الحركة">
              <b-select
                placeholder="اختر"
                class="is-medium"
                expanded
                v-model="requestInfo.TypeOfTrans"
              >
                <option value="All">كل</option>
                <option value="C">ايداع</option>
                <option value="D">خصم</option>
              </b-select>
            </b-field> -->
            </section>
            <a class="button btn primary-btn btn-align modal-dismiss is-bold is-medium mb-40"
              @click="validateBeforeSubmit()">
              <b>عرض الكشف</b>
            </a>
          </div>
        </div>

        <div class="columns is-centered" v-if="
          requestsuccess && !requestfail
        ">
          <div class="column is-narrow" id="printMe">
            <!-- Login form -->

            <h4 class="title is-4 has-text-white pb-40" v-if="bydate == false">
              كشف أخر 30 حركة - رقم حساب {{ requestInfo.AccountNo }}
            </h4>

            <h4 class="title is-4 has-text-white pb-40" v-else>
              كشف الحساب من {{ requestInfo.DateFrom }} الى
              {{ requestInfo.DateTo }}
            </h4>
            <table class="table is-striped mb-40" border="solid" cellpadding="10">
              <thead>
                <tr>
                  <th>تاريخ الحركة</th>
                  <th>القيمة</th>
                  <th>بيان الحركة</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="statement in statements.statements.slice().reverse()" :key="statement.id">
                  <td>{{ statement.transactionDate }}</td>
                  <td>{{ statement.transactionAmount }}</td>
                  <td>{{ statement.transactionDiscretion }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="columns is-centered" v-if="
          !requestsuccess && requestfail
        ">
          <div class="column is-6 is-offset-3 mt-40 mb-90">
            <!-- Login form -->
            <div class="flex-card raised padding-20">
              <div class="square-icon-box rounded danger mt-20">
                <div class="icon-box-wrapper">
                  <div class="icon-box">
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </div>
              <div class="animated preFadeInLeft fadeInLeft pb-90">
                <hr />
                <h1 class="title is-4 pb-10">فشل في طلب</h1>
                <h1 class="subtitle is-5">{{ errormessage }}</h1>
                <hr />
              </div>
            </div>
          </div>
        </div>

        <div class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp">
          <a class="button btn primary-btn btn-align modal-dismiss is-bold is-medium ml-20" v-if="statements != null"
            @click="print()">
            <b>طباعة</b>
          </a>
          <a class="button is-dark btn-align modal-dismiss is-bold is-medium" @click="$router.go('-1')">
            <b>العودة</b>
          </a>
        </div>
      </div>


    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";

export default {
  data() {
    return {
      requestloading: true,
      requestsuccess: false,
      requestfail: false,
      errormessage: "",
      statements: null,
      dateform: false,
      bydate: false,
      year: new Date().getFullYear(),
      requestInfo: {
        Token: null,
        Id: null,
        AccountNo: null,
        TransactionNo: 30,
        DateFrom: this.first_day,
        DateTo: this.last_day,
        TypeOfTrans: "All",
      },
    };
  },
  computed: {
    // first_day: function() { return moment({ year: this.year }).startOf().toDate(); },
    // last_day: function() { return moment({ year: this.year+1 }).startOf().subtract(1, 'd').toDate(); },
    //     years () {
    //   const year = new Date().getFullYear()
    //   return Array.from({length: year - 2010}, (value, index) => 2010 + index)
    // },
    mindate: function () {
      return moment(this.requestInfo.DateFrom).toDate();
    },

    DateFromMaxdate: function () {
      return moment(this.requestInfo.DateTo).toDate();
    },
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.getByDate();
          return;
        }
      });
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe");
    },
    getLast30() {
      this.requestloading = true;

      axios
        .post("account/statement/byno", this.requestInfo)
        .then((response) => {
          this.requestloading = false;
          this.$root.kick(response.data.message);
          if (response.data.status === "success") {
            this.statements = JSON.parse(response.data.result);
            this.requestsuccess = true;
            this.requestfail = false;
          } else if (response.data.status === "fail") {
            this.requestsuccess = false;
            this.errormessage = response.data.message;
            this.requestfail = true;
            // alert(response.data);
          }
        })
        .catch((error) => {
          this.requestloading = false;
          this.isLoading = !this.isLoading;
          this.message = true;
        });
    },

    byDate() {
      this.dateform = true;
      this.bydate = true;
    },

    getByDate() {
      this.requestloading = true;
      // this.dateform = false;

      this.requestInfo.DateFrom = moment(this.requestInfo.DateFrom).format(
        "DD-MM-YYYY"
      );
      this.requestInfo.DateTo = moment(this.requestInfo.DateTo).format(
        "DD-MM-YYYY"
      );

      const DATA = {
        dateFrom: this.requestInfo.DateFrom,
        dateTo: this.requestInfo.DateTo,
        id: this.requestInfo.Id
      }
      axios
        .post(
          "account/statement/bydates",
          DATA,
          // { responseType: "blob" }
        )
        .then((response) => {
          this.requestloading = false;
          this.$root.kick(response.data.message);
          if (response.data.status === "fail") {
            this.requestsuccess = false;
            this.errormessage = response.data.message;
            this.requestfail = true;
            // alert(response.data);
          } else {
            this.statements = {statements:response.data.result};
            this.requestfail = false;
            this.requestsuccess = true
            // var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            // var fileLink = document.createElement("a");

            // fileLink.href = fileURL;
            // fileLink.setAttribute(
            //   "download",
            //   "saharaOnline-detailed-statement-(AccountNo:" +
            //     this.requestInfo.AccountNo +
            //     ")-(from:" +
            //     this.requestInfo.DateFrom +
            //     ")-(to:" +
            //     this.requestInfo.DateTo +
            //     ").pdf"
            // );
            // document.body.appendChild(fileLink);

            // fileLink.click();
            // this.requestInfo.DateFrom = moment().toDate();
            // this.requestInfo.DateTo = null;

          }
        })
        .catch((error) => {
          this.requestInfo.DateFrom = moment().toDate();
          this.requestInfo.DateTo = null;
          this.isLoading = !this.isLoading;
          this.message = true;
          this.requestloading = false;
          this.requestfail = true;
        });
    },
  },
  created() {
    this.$validator.localize("ar", {
      messages: arabic.messages,
      attributes: {
        DateFrom: "تاريخ الابتدائي",
        DateTo: "تاريخ النهائي",
      },
    });

    moment.locale("en");
    var user = JSON.parse(localStorage.getItem("user"));

    this.requestInfo.Id = user[1];

    axios
      .get("customer/basicData/" + this.requestInfo.Id)
      .then((response) => {
        this.$root.kick(response.data.message);

        this.requestInfo.AccountNo = response.data.result.MainAccountNo;
        this.requestInfo.DateFrom = new Date().setDate(
          new Date().getDate() - 1
        );
        this.requestInfo.DateTo = new Date();
        let token = localStorage.getItem("token");
        this.requestInfo.Token = token;

        this.requestloading = false;
      })
      .catch((error) => {
        this.requestloading = false;
      });
  },
};
</script>
